import { Button, DatePicker, DateRange, Group, IconWarning, Modal, OptionInterface, Table, TablePagination, TablePreferences } from "@veneer/core";
import '../../../assets/css/views/activations/activationsAssignation.css'
import CustomButton from "./customButton";
import ActivationAssignationLogic, { IValuesSelector } from "./activationAssignationLogic";
import { useTranslation } from "react-i18next";
import SelectWrapper from "./selectWrapper";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ModalScreen from "./ModalScreen";
import { CreateActivationAssignation } from "./createActivationAssignation";
import LoaderModal from "../../../components/Loader/loaderModal";

export type onClearFormat = 'subRetailID' | 'posCodeID'

const ActivationAssignationScreen = () => {
    const {
        filters, setFilters, getAssignmentOfActivation, tableData, checkedStates, columns2, columnsWidth, itemSelected,
        loadingTableData, optionsActivation, allSelected, currentPage, setCurrentPage, handleSelectAll, setActivationIdSelected,
        handleEditMassStartDate, handleEditMassEndDate, editMassStartDate, editMassEndDate, isEndDateOutsideRangeEditMass,
        handleUpdateAssingation, handleDeleteAssingation, openModal, setOpenModal, buttonToEdit, activationIdSelected,
        handleCloseModal, handleOpenEditModal, openCreateActivation, setOpenCreateActivation, optionPosList, optionPosListCopy,
        optionsSubReatil, getDataSubretail, optionsSubReatilCopy, setOptionsSubReatil, getPointOfsaleByList, messageSentActivation,
        setOptionPosList, accordionData, setAccordionData, mapCreateActivationByPos, setOpenModalActivationSent, openModalActivationSent,
        singlestartDate, singleEndDate, filterActivations, loadingSendInfo, setTableData, setPageNumber, totalLength, pageNumber,setDataFiltered
    } = ActivationAssignationLogic();
    const [t] = useTranslation("global");
    const [pageSize, setPageSize] = useState<number>(20);
    const [subRetailID, setSubRetailID] = useState<number[]>([]);
    const [PosCodeID, setPosCodeID] = useState<number[]>([]);
    const [isCloseSelect, setIsCLoseSelect] = useState<boolean>(false);
    const prevSubRetailIDRef = useRef<number[]>(subRetailID);

    const tablePreferences: TablePreferences = {
        width: columnsWidth,
    };

    const onChangeActivation = (selectedOption: IValuesSelector) => {
        const selectedValue = selectedOption.value;
        setCurrentPage(1)
        setPageNumber(1)
        setTableData([])
        setDataFiltered([])
        if (selectedValue === activationIdSelected) {
            setActivationIdSelected(0);
            setFilters((prev) => ({
                ...prev,
                valueActivation: [],
            }));
        } else {
            setActivationIdSelected(selectedValue);
            getAssignmentOfActivation(selectedValue, 1);
            setFilters((prev) => ({
                ...prev,
                valueActivation: [selectedValue],
            }));
        }
    };


    const handleChangeSubRetailList = (e: IValuesSelector) => {
        setAccordionData([])
        setPosCodeID([])
        let value = e.value
        setSubRetailID((prev) => {
            if (prev.includes(value)) {
                return prev.filter(item => item !== value);
            }
            return [...prev, value];
        });
    }

    const handleChangePos = (e: IValuesSelector) => {
        let value = e.value
        setPosCodeID((prev) => {
            if (prev.includes(value)) {
                return prev.filter(item => item !== value);
            }
            return [...prev, value];
        });
        setAccordionData((prev) => {
            if (PosCodeID.includes(value)) {
                return prev.filter(item => item?.id !== value);
            }
            return [...prev, {
                id: e.value,
                posCode: e.value,
                posName: e.label,
                subRetailId: Number(e.subRetailID!),
                startDate: '',
                endDate: ''
            }];
        })
    }

    useEffect(() => {
        setIsCLoseSelect((prev) => prev && false)
        if (prevSubRetailIDRef.current !== subRetailID && subRetailID.length > 0) {
            setPosCodeID([])
            setOptionPosList([])
            prevSubRetailIDRef.current = subRetailID;
            getPointOfsaleByList(subRetailID, 'pointofsale')
        }
    }, [isCloseSelect])

    const handleOnclickPos = () => {
        setIsCLoseSelect(true)
        return true
    };

    const onClearActivation = () => {
        setActivationIdSelected(0)
        setTableData([])
        setPageNumber(1)
        setFilters((prev) => ({
            ...prev,
            valueActivation: [],
        }));
    };

    const modalCreateActivation = useCallback(() => {
        if (optionsSubReatilCopy.length <= 0) {
            getDataSubretail()
        }
    }, [])


    const handleAddActivationBySubretail = () => {
        setSubRetailID([])
        setPosCodeID([])
        getPointOfsaleByList(subRetailID, '')
    };
    const handleAddActivationByPos = () => {
        mapCreateActivationByPos()
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const handlePageSizeChange = (
        event: React.MouseEvent<HTMLElement>,
        option: OptionInterface<number>
    ) => {
        setPageSize(option.value);
    };

    const handleClear = (value: onClearFormat) => {
        setAccordionData([])
        if (value === 'subRetailID') {
            setSubRetailID([])
            prevSubRetailIDRef.current = []
        } else if (value === 'posCodeID') {
            setPosCodeID([])
        }
    }

    const handleCloseModalByAddActivation = () => {
        setAccordionData([])
        setPosCodeID([])
        setOpenCreateActivation(false)
    }

    const filterOptions = useCallback((query = '', type: onClearFormat) => {
        if (type === 'subRetailID') {
            if (query === '') {
                setOptionsSubReatil(optionsSubReatil);
            } else {
                const filtered = optionsSubReatilCopy.filter(item => {
                    return item.label && typeof item.label === 'string' && item.label.toLowerCase().includes(query.toLowerCase());
                });

                setOptionsSubReatil(filtered);
            }
        } else if (type === 'posCodeID') {
            if (query === '') {
                setOptionPosList(optionPosListCopy);
            } else {
                const filtered = optionPosListCopy.filter(item => {
                    return item.label && typeof item.label === 'string' && item.label.toLowerCase().includes(query.toLowerCase());
                });

                setOptionPosList(filtered);
            }
        }
    }, [optionsSubReatil, optionsSubReatilCopy, optionPosList, optionPosListCopy]);


    const paginationProps: TablePagination = {
        currentPage,
        onPageChange: handlePageChange,
        onPageSizeChange: handlePageSizeChange,
        pageSize,
        totalItems: tableData.length < totalLength ? tableData.length + pageSize : tableData.length,
    };

    const firstValueSlice = ((currentPage - 1) * pageSize)
    const secondValueSlice = ((currentPage - 1) * pageSize + pageSize)
    const resolveData = useCallback(() => {
        return tableData.slice(firstValueSlice, secondValueSlice);
    }, [tableData, currentPage]);

    const displayedData = useMemo(() => {
        return resolveData();
    }, [resolveData]);

    const resolveOptionPos = useCallback(() => {
        return optionPosList;
    }, [optionPosList]);

    const displayOptionPos = useMemo(() => {
        return resolveOptionPos();
    }, [resolveOptionPos]);

    const disableButtonsMass = Object.keys(checkedStates).length > 0


    useEffect(() => {
        if (displayedData.length === 0 && currentPage > 1) {
            const newPage = pageNumber + 1
            setPageNumber(newPage);
            getAssignmentOfActivation(activationIdSelected, newPage);
        }
    }, [currentPage]);

    const UpdateActivationComponent = () => {
        return (
            <>
                {
                    Object.keys(checkedStates).length > 1 ?
                        (<ModalScreen
                            show={openModal}
                            title={buttonToEdit ? t("modal.selectionManagement") : t("modal.selectionManagement")}
                            onClose={handleCloseModal}
                            footer={<div className="footerModal">
                                <Group>
                                    <Button onClick={handleCloseModal}>
                                        {t("header.cancel")}
                                    </Button>
                                    <div style={{ marginLeft: "50px" }}>
                                        <Button
                                            appearance="secondary"
                                            onClick={buttonToEdit ? handleUpdateAssingation : handleDeleteAssingation}
                                            disabled={buttonToEdit ? (editMassStartDate !== undefined && editMassEndDate !== undefined) ? false : true : false}
                                        >
                                            {buttonToEdit ? t("header.save") : t("header.delete")}
                                        </Button>
                                    </div>
                                </Group></div>}
                        >
                            <div className="modalContentWrapper">
                                <p className="descriptionModal">{buttonToEdit ? t("modal.AssignNewDateMass") : t("modal.deleteAssignmentsMass")}</p>
                                {buttonToEdit && <div className="customDatePickerMain">
                                    <div >
                                        <DatePicker
                                            className="customDatePicker"
                                            blockPastDates
                                            calendarOrientation={["left", "down"]}
                                            label="Start Date"
                                            onChange={handleEditMassStartDate}
                                            orientation="horizontal"
                                            value={editMassStartDate}
                                            format="LL"
                                            clearIcon={false}
                                        />
                                    </div>
                                    <div >
                                        <DatePicker
                                            className="customDatePicker"
                                            clearIcon={false}
                                            calendarOrientation={["left", "down"]}
                                            label="End Date"
                                            onChange={handleEditMassEndDate}
                                            orientation="horizontal"
                                            value={editMassEndDate}
                                            format="LL"
                                            disabled={false}
                                            isOutsideRange={isEndDateOutsideRangeEditMass}
                                        />
                                    </div>
                                </div>}
                            </div>
                        </ModalScreen>) :
                        (<ModalScreen
                            show={openModal}
                            title={buttonToEdit ? t("header.updateDatePOS") : t("modal.questionDeleteAssingation")}
                            onClose={handleCloseModal}
                            footer={<div className="footerModal">
                                <Group>
                                    <Button onClick={handleCloseModal}>
                                        {t("header.cancel")}
                                    </Button>
                                    <div style={{ marginLeft: "40px" }}>
                                        <Button
                                            appearance="secondary"
                                            onClick={buttonToEdit ? handleUpdateAssingation : handleDeleteAssingation}
                                            disabled={buttonToEdit ? (editMassStartDate !== undefined && editMassEndDate !== undefined) ? false : true : false}
                                        >
                                            {buttonToEdit ? t("header.save") : t("header.delete")}
                                        </Button>
                                    </div>
                                </Group></div>}
                        >
                            <div className="modalContentWrapper">
                                <p className="descriptionSingleModal">{itemSelected.pointOfSale ?? ''}</p>
                                <p className="descriptionSingleModal">{itemSelected.posOfCode ?? ''}</p>
                                {buttonToEdit && <div className="customDatePickerMain">
                                    <div >
                                        <DatePicker
                                            className="customDatePicker"
                                            blockPastDates
                                            calendarOrientation={["left", "down"]}
                                            label={"Start Date  " + singlestartDate}
                                            onChange={handleEditMassStartDate}
                                            orientation="horizontal"
                                            value={editMassStartDate}
                                            format="LL"
                                            clearIcon={false}
                                        />
                                    </div>
                                    <div >
                                        <DatePicker
                                            className="customDatePicker"
                                            clearIcon={false}
                                            calendarOrientation={["left", "down"]}
                                            label={"End Date  " + singleEndDate}
                                            onChange={handleEditMassEndDate}
                                            orientation="horizontal"
                                            value={editMassEndDate}
                                            format="LL"
                                            disabled={false}
                                            isOutsideRange={isEndDateOutsideRangeEditMass}
                                        />
                                    </div>
                                </div>}
                            </div>
                        </ModalScreen>)
                }</>
        )
    }

    return (
        <div className="activationContainer">
            <div style={{ flexDirection: 'column' }}>
                <h4>{t("header.activationAssignment")}</h4>
            </div>
            <div className="activationContainerButtons">
                <div className="buttonColumn">
                    <SelectWrapper
                        options={optionsActivation}
                        onChange={onChangeActivation}
                        onClear={onClearActivation}
                        onSearch={filterActivations}
                        value={filters.valueActivation}
                        disabled={false}
                        showSearch={true}
                        label={t("header.selectActivation2")}
                    />
                    <CustomButton onClick={() => {
                        modalCreateActivation()
                        setOpenCreateActivation(true)
                    }}
                        disabled={filters.valueActivation.length <= 0}>
                        {t("header.addSchedule")}
                    </CustomButton>
                </div>
                <div className="buttonColumn">
                    <CustomButton onClick={handleSelectAll}
                        disabled={displayedData.length <= 0}>
                        {!allSelected ? t("modal.selectAll") : t("modal.deselectAll")}
                    </CustomButton>
                    <CustomButton onClick={handleOpenEditModal} disabled={!disableButtonsMass}>
                        {t("modal.editSelection")}
                    </CustomButton>
                    <CustomButton onClick={() => setOpenModal(true)} disabled={!disableButtonsMass}>
                        {t("modal.deleteSelection")}
                    </CustomButton>
                </div>
            </div>
            <div className="tableContainer">
                {/* Tabla de puntos de venta */}
                <Table
                    behavior={{
                        type: 'singlePage',
                    }}
                    css={{
                        height: '70vh',
                    }}
                    columnResize
                    loading={loadingTableData}
                    columns={columns2}
                    data={displayedData}
                    loadingDataLength={5}
                    preferences={tablePreferences}
                    pagination={paginationProps}
                    showFilters={true}
                    customNoItems={
                        ((displayedData.length === 0 && currentPage > 1)) ? (null)
                            :
                            <div className="customNoItemsActivation">
                                <IconWarning
                                    size={150}
                                    className="IconCustomNoItemsActivation"
                                />
                                <div className="MessageNoActivationsFound">
                                    {t("header.noActivationsFound")}
                                </div>
                            </div>
                    }
                />
            </div>
            {openModal && <UpdateActivationComponent />}

            {openCreateActivation && (
                <CreateActivationAssignation
                    handleCloseModal={() => handleCloseModalByAddActivation()}
                    editMassStartDate={editMassStartDate}
                    editMassEndDate={editMassEndDate}
                    handleEditMassStartDate={handleEditMassStartDate}
                    handleEditMassEndDate={handleEditMassEndDate}
                    onClear={handleClear}
                    optionsSubReatil={optionsSubReatil}
                    optionPos={displayOptionPos}
                    filterOptions={filterOptions}
                    onchangeSubRetail={handleChangeSubRetailList}
                    onchangePos={handleChangePos}
                    onclickPos={handleOnclickPos}
                    subRetailID={subRetailID}
                    posCodeID={PosCodeID}
                    handleCreateActivationBySubRetail={handleAddActivationBySubretail}
                    accordionData={accordionData}
                    setAccordionData={setAccordionData}
                    handleCreateActivationByPos={handleAddActivationByPos}
                />
            )}

            <div style={{ position: "relative" }}>
                <Modal
                    align="start"
                    id="modal-CreateOk"
                    show={openModalActivationSent}
                    onClose={() => setOpenModalActivationSent(false)}
                    footer={<Button onClick={() => setOpenModalActivationSent(false)}>OK</Button>}
                    title={t("modal.message")}
                >
                    <p>{messageSentActivation}</p>
                </Modal>
            </div>
            {loadingSendInfo &&
                <div>
                    <LoaderModal >
                        <div> {t('header.wait')}</div>
                    </LoaderModal>
                </div>
            }


        </div>

    )
}

export default ActivationAssignationScreen;